import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { index: { type: Number, default: 0 } }

  connect() {
    this.showTab(this.indexValue)
  }

  select(event) {
    const index = parseInt(event.params?.index ?? 0, 10)
    this.indexValue = index
    this.showTab(index)
  }

  showTab(index) {

    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add("border-primary-500", "text-primary-600", "dark:text-primary-400")
        tab.classList.remove("border-transparent", "text-gray-500", "hover:text-gray-700", "dark:text-gray-400")
        tab.setAttribute("aria-selected", "true")
      } else {
        tab.classList.remove("border-primary-500", "text-primary-600", "dark:text-primary-400")
        tab.classList.add("border-transparent", "text-gray-500", "hover:text-gray-700", "dark:text-gray-400")
        tab.setAttribute("aria-selected", "false")
      }
    })

    this.panelTargets.forEach((panel, i) => {
      if (i === index) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }
}
